export default [
  'Block',
  'Capture',
  'CaptureTextArea',
  'Children',
  'Column',
  'Horizontal',
  'Image',
  'List',
  'ViewsModalOverlay',
  'ViewsModalOverlayContent',
  'Spring',
  'Svg',
  'SvgCircle',
  'SvgDefs',
  'SvgEllipse',
  'SvgGroup',
  'SvgLine',
  'SvgLinearGradient',
  'SvgPath',
  'SvgPolygon',
  'SvgPolyline',
  'SvgRadialGradient',
  'SvgRect',
  'SvgStop',
  'SvgSymbol',
  'SvgText',
  'SvgUse',
  'Table',
  'Text',
  'Timing',
  'Vertical',
  'View',
]
